'use client'

import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { tokens } from 'ui/src/theme/tokens.css'

type SpaceSize = 'sm' | 'md' | 'lg' | 'xl'

type Props = {
  size: SpaceSize
}

const spaceBlockScale = {
  sm: tokens.space.xs,
  md: tokens.space.md,
  lg: tokens.space.lg,
  xl: tokens.space.xl,
} as const

type InlineSpaceBlockProps = SbBaseBlockProps<Props>

export function InlineSpaceBlock({ blok }: InlineSpaceBlockProps) {
  return <div style={{ height: spaceBlockScale[blok.size] }} {...storyblokEditable} />
}

InlineSpaceBlock.blockName = 'inlineSpace'
